import { useTranslation } from 'react-i18next'
import ErrorPage from './ErrorPage'

interface ServerErrorProps {
  errorId?: string
}

export default function ServerError({ errorId }: ServerErrorProps) {
  const { t } = useTranslation()

  const message = errorId
    ? t('errors.pages.500.messageWithId', { errorId })
    : t('errors.pages.500.message')

  return (
    <ErrorPage
      status={500}
      title={t('errors.pages.500.title')}
      message={message}
      showHomeButton={true}
      showRetryButton={true}
    />
  )
}
